var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "../../Banners/BigBanner/BigBanner", "../../UI/TitlesElement/TitlesElement", "../TeaserMain/TeaserMain", "./PreviewScale"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("../../Banners/BigBanner/BigBanner"), require("../../UI/TitlesElement/TitlesElement"), require("../TeaserMain/TeaserMain"), require("./PreviewScale"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.BigBanner, global.TitlesElement, global.TeaserMain, global.PreviewScale);
    global.TeaserPreview = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _BigBanner, _TitlesElement, _TeaserMain, _PreviewScale) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _BigBanner = _interopRequireDefault(_BigBanner);
  _TitlesElement = _interopRequireDefault(_TitlesElement);
  _TeaserMain = _interopRequireDefault(_TeaserMain);
  _PreviewScale = _interopRequireDefault(_PreviewScale);

  var TeaserPreview = function TeaserPreview(_ref) {
    var image = _ref.image,
        title = _ref.title,
        subtitle = _ref.subtitle,
        type = _ref.type;
    return /*#__PURE__*/_react.default.createElement(_PreviewScale.default, {
      type: type
    }, type === 'banner' ? /*#__PURE__*/_react.default.createElement(_BigBanner.default, {
      id: "preview_".concat(type),
      teaser: {
        title: title,
        subtitle: subtitle,
        images: [image]
      },
      theme: "next",
      duration: 25
    }) : /*#__PURE__*/_react.default.createElement(_TeaserMain.default, {
      title: title,
      className: "tvguide-highlight",
      focus: "guide",
      hover: "overlay",
      breakpointFormat: {
        xsmall: type,
        small: type,
        medium: type,
        large: type,
        xlarge: type,
        xxlarge: type
      },
      titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
        display: "TVGUIDE",
        title: title,
        subtitle: subtitle
      }),
      images: [image],
      duration: 25
    }));
  };

  TeaserPreview.propTypes = {
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    type: _propTypes.default.oneOf(['landscape', 'square', 'banner']),
    image: _propTypes.default.shape().isRequired
  };
  var _default = TeaserPreview;
  _exports.default = _default;
});